import React from "react";
import Title from "../atoms/Title";
import SelectBox from "../atoms/SelectBox";
import StatisticBox from "./StatisticBox";
import { useStateContext } from "../../context/AdminDashboard/HomeContext";
import loading from "../../photos/Spinner-1.9s-137px.gif";

const Statistics = () => {
  const { satatistic, changeStatistic, statisticLoaded } = useStateContext();

  // Define the statistic boxes data
  const statisticBoxes = [
    {
      iconName: "cpuS",
      title: "دستگاه‌ها",
      items: ["متصل", "فعال", "انبار"],
      nums: [
        satatistic.device_connected,
        satatistic.device_active,
        satatistic.device_storehouse,
      ],
    },
    {
      iconName: "user",
      title: "کاربر‌ها",
      items: ["کل", "مالک‌ها", "دارای اشتراک"],
      nums: [
        satatistic.user_number,
        satatistic.user_owner,
        satatistic.user_subscribed,
      ],
    },
    {
      iconName: "wallet",
      title: "مالی",
      items: ["کل درآمد", "درآمد دستگاه", "درآمد اشتراک"],
      nums: [
        satatistic.financial_total,
        satatistic.financial_device,
        satatistic.financial_subscribe,
      ],
      correns: true,
    },
    {
      iconName: "boxS",
      title: "سفارش‌ها",
      items: ["جدید", "درجریان", "تحویل شده"],
      nums: [
        satatistic.new_order,
        satatistic.progress_order,
        satatistic.delivered_order,
      ],
    },
    {
      iconName: "driver",
      title: "پنل‌های متصل",
      items: ["موجودی پیامکی", "موجودی درگاه", "در حال تسویه"],
      nums: [
        satatistic.panel_massage_inventory,
        satatistic.panel_port_inventory,
        satatistic.panel_settling_inventory,
      ],
      correns: true,
    },
  ];

  return (
    <div
      className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px"
      dir="rtl">
      <div className="flex flex-row justify-between items-center h-10">
        <Title text="آمارهـــای سیسـتم مدیــــریتـی ویــــاک" />
        <SelectBox
          wbox={"141px"}
          able={true}
          selected="بر اساس ماه جاری"
          option1="3 ماه"
          option2="6 ماه"
          option3="12 ماه"
          option4="بر اساس ماه جاری"
          val1="3"
          val2="6"
          val3="12"
          val4="1"
          onChange={changeStatistic}
        />
      </div>
      {/* // Render a loading spinner if the statistics are still loading */}
      {statisticLoaded ? (
        <div className="flex justify-center items-center w-24 h-72 m-auto bg-transparent">
          <img src={loading} alt="" />
        </div>
      ) : (
        <div className="mt-7.5px pb-7.5px font-medium flex flex-row justify-between">
           {/* // Map through the statisticBoxes and render StatisticBox for each */}
          {statisticBoxes.map((box, index) => (
            <StatisticBox
              key={index}
              iconName={box.iconName}
              title={box.title}
              item1={box.items[0]}
              item2={box.items[1]}
              item3={box.items[2]}
              item1_num={box.nums[0]}
              item2_num={box.nums[1]}
              item3_num={box.nums[2]}
              correns={box.correns}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Statistics;
